import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import solutionBiseccionReducer from './solutionBiseccionReducer';
import solutionNewtonReducer from './solutionNewtonReducer';
import matrixReducer from './matrixReducer';
import vrpReducer from './vrpReducer';

export default combineReducers({
   form: formReducer,
   solution_biseccion: solutionBiseccionReducer,
   solution_newton: solutionNewtonReducer,
   matrix: matrixReducer,
   route: vrpReducer
});